module.exports = __webpack_public_path__ + "static/alexPrime-c614654bbc907e93356386ddbe34f063.pdf";